<script>
    import hotspotLogo from "../assets/img/hotspot.webp";
    import { onMount } from "svelte";

    export let store;

    let phoneNumber = store.phoneNumber;

    async function handleSubmit() {
        if (phoneNumber !== null) {
            try {
                const response = await fetch("/pin/update/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        phone_number: phoneNumber,
                        pin: parseInt(document.getElementById("pin").value),
                    }),
                });

                if (response.ok) {
                    console.log("PIN set successfully");
                } else {
                    console.error("Failed to set PIN");
                }
            } catch (error) {
                console.error("Error setting PIN:", error);
            }
        } else {
            console.error("Phone number not found");
        }
    }
</script>

<div class="flex flex-col items-center justify-center mt-24 px-4">
    <img src={hotspotLogo} alt="TooMuchWifi Hotspot logo" class="w-32 mb-6" />

    <h1 class="text-lg font-semibold">Update your PIN for this account</h1>
    <div
        class="w-full bg-gray-200 font-bold my-4 py-2 px-4 rounded text-center"
    >
        {phoneNumber}
    </div>

    <p class="text-sm mb-2">Enter 4-digit PIN</p>
    <form on:submit={handleSubmit} class="w-full max-w-md mx-auto">
        <input
            type="pin"
            id="pin"
            required
            maxlength="4"
            class="block w-full text-xl p-3 mb-4 border border-gray-300 rounded focus:outline-none
        text-center focus:ring-2 focus:ring-blue-500"
            on:input={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "");
            }}
        />
        <button
            type="submit"
            class="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
            Submit
        </button>
    </form>
</div>
